import { MobXProviderContext, observer } from "mobx-react";
import React from "react";
const Viewer = React.lazy(() => import("../DocXViewer/DocXViewer"));

const MS_FILE_EXTENSIONS = ["DOCX", "DOC", "PPT", "PPTX", "XLS", "XLSX"];

export const DocumentViewer = observer(({ documentURL, fileExtension }) => {
  if (MS_FILE_EXTENSIONS.includes(fileExtension)) {
    return <Viewer src={documentURL} />;
  }

  const store = React.useContext(MobXProviderContext);
  const { uiStore } = store;
  const { isDesktop } = uiStore;

  if (isDesktop) {
    return (
      <object data={documentURL} type="application/pdf">
        <embed className="pdfobject" src={documentURL} type="application/pdf" />
      </object>
    );
  } else {
    return (
      <div
        style={{ height: "100%" }}
        dangerouslySetInnerHTML={{
          __html: `<object
        data=https://docs.google.com/gview?embedded=true&url=${documentURL}
        ></object>`,
        }}
      />
    );
  }
});
